import { Column, Index } from 'typeorm';
import type { ListPreviewStatus } from '../../constants/trade-shows';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';

/**
 * PD-17771: what a list would do, worked out in the background. A list of thousands
 * takes minutes to match and a request has a minute at most, so the preview is a job
 * and the page follows this row, which any server can answer for. Not audited: it is
 * a working result, and the import it leads to has its own record.
 */
@Entity('list_preview', {}, { auditable: false })
@Index('idx_list_preview_record', ['importerKey', 'recordId'])
export class ListPreviewEntity extends BaseEntity {
	@Column('varchar', { name: 'importerKey', length: 100 })
	public importerKey!: string;

	/** The show or association the list is for. */
	@Column('int', { name: 'recordId' })
	public recordId!: number;

	/** What was asked: the role, and the file or the directory. */
	@Column('json', { name: 'request' })
	public request!: Record<string, unknown>;

	@Column('varchar', { name: 'status', length: 20, default: 'pending' })
	public status!: ListPreviewStatus;

	@Column('int', { name: 'totalRows', default: 0 })
	public totalRows!: number;

	@Column('int', { name: 'matchedRows', default: 0 })
	public matchedRows!: number;

	/** The finished preview, as the page shows it. */
	@Column('json', { name: 'result', nullable: true })
	public result?: Record<string, unknown> | null;

	/** Positions of rows already on the list, which the import leaves out. */
	@Column('json', { name: 'skipRows', nullable: true })
	public skipRows?: Array<number> | null;

	@Column('varchar', { name: 'errorMessage', length: 500, nullable: true })
	public errorMessage?: string | null;
}
